module.exports = __webpack_public_path__ + "static/media/icon_file_upload.49932ec1.svg";